import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import { onlyUpdateForKeys } from 'recompose';
import Link from 'components/general/Link/Link';
import LinkProps from 'utils/ts/LinkProps';

const classes = {
  item: 'list-nav__item',
  itemActive: 'list-nav__item--is-current',
};

const ListNav: React.SFC<ListNavPropDef> = ({
  items,
  currentID,
  onItemClick,
}) => (
  <ul className="list-nav">
    {items.map(item => (
      <li
        key={`list-nav-item-${item.title}`}
        className="list-nav__section"
        onClick={onItemClick}
      >
        {item.to ? (
          <h3 className="list-nav__section-title">
            <Link
              to={item.to}
              className={classNames(classes.item, {
                [classes.itemActive]: R.equals(item.id, currentID),
              })}
            >
              {item.title}
            </Link>
          </h3>
        ) : (
          <h3 className="list-nav__title">
            <span>
              {item.title}
            </span>
          </h3>
        )}
        <ul className="list-nav__items">
          {item.children && item.children.map(subItem => (
            <li
              key={`list-nav-item-${subItem.title}`}
              onClick={onItemClick}
            >
              <Link
                to={subItem.to}
                className={classNames(classes.item, {
                  [classes.itemActive]: R.equals(subItem.id, currentID),
                })}
              >
                {subItem.title}
              </Link>
            </li>
          ))}
        </ul>
      </li>
    ))}
  </ul>
);

ListNav.defaultProps = {
  items: [],
};

export interface ListNavItemChildPropDef {
  // Used to identify current item
  id: string|number;
  title: string;
  to: LinkProps;
  exact?: boolean;
}

export interface ListNavItemPropDef {
  // Used to identify current item
  id: string|number;
  title: string;
  to?: LinkProps;
  children: ListNavItemChildPropDef[];
}

export interface ListNavPropDef {
  items: ListNavItemPropDef[];
  onItemClick?();
  // ID of the currently selected navItem
  currentID?: string|number;
}

export default onlyUpdateForKeys(
  ['items'],
)(ListNav);

